import(/* webpackMode: "eager" */ "/vercel/path0/app/(static)/layout.tsx");
